var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("span", [
      _vm._v(
        _vm._s(
          _vm.$t("notification.formRestored", {
            user: _vm.$_.get(_vm.activity, "actorUser.name"),
            formName: _vm.$_.get(_vm.activity, "payload.formName"),
            formId: _vm.$_.get(_vm.activity, "payload.formId"),
          })
        )
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }